import { Collapse, Divider, useMediaQuery } from "@mui/material";
import { useState } from "react";
import imgBannerIgualdadeSalarial from "../../../../assets/images/empresa/docs-politicas/banner_link_igualdade_salarial 1.png";
import imgBannerPoliticaPrivacidade from "../../../../assets/images/empresa/docs-politicas/banner_link_privacidade 1.png";
import imgBannerRelatorios from "../../../../assets/images/empresa/docs-politicas/RELARORIO_SUSTENTABILIDADE.png";
import minusIcon from "../../../../assets/svgs/icons/minus-icon.svg";
import plusIcon from "../../../../assets/svgs/icons/plus-icon.svg";
import DefaultButton from "../../../../components/buttons/default-button";
import { DOCUMENT_PATHS, openDocument } from "../../../../constants/documents";
import DefaultText from "../../../../components/typography/default-text";
import styles from "./styles.module.css";

const DocsPoliticas: React.FC = () => {

  const [openPolitics, setOpenPolitics] = useState<boolean>(false);
  const isMobile = useMediaQuery('(max-width: 899px)');

  const handleClickCollapse = () => {
    setOpenPolitics(openPolitics => !openPolitics);
  }

  return (
    <>
      <div className={styles["sub-page-content"]}>
        <div className={styles["sgi-policy-collapse"]}>
          <div onClick={handleClickCollapse} role="button" className={styles["sgi-policy"]}>
            <DefaultText>
              Políticas, relatórios e documentos do <span style={{ fontFamily: 'Montserrat-Bold' }}>Sistema de Gestão Integrado - SGI</span>
            </DefaultText>
            <img src={openPolitics ? minusIcon : plusIcon} alt="Seta para a esquerda" />
          </div>
          <Divider variant="fullWidth" flexItem sx={{ background: 'rgba(28, 55, 17, 0.25)', backgroundColor: 'rgba(28, 55, 117, 0.25)' }} />
          <Collapse in={openPolitics} unmountOnExit timeout={500}>
            <div className={styles["sgi-policy-content"]}>
              <DefaultText lineHeight="16px" size="xs" color="var(--secondary-medium-grey)">DATA: 06/08/24</DefaultText>
              <DefaultText size="medium">POLÍTICA DE SGI QUALIDADE MEIO AMBIENTE SAÚDE E SEGURANÇA OCUPACIONAL</DefaultText>
              <DefaultText lineHeight="24px" size="small">1 – OBJETIVO</DefaultText>
              <DefaultText lineHeight="16px" size="xs" color="var(--secondary-medium-grey)">
                Definir diretrizes e estabelecer objetivos para unificação de processos de gerenciamento e informações ao que tange:
                QUALIDADE, MEIO AMBIENTE, SAÚDE E SEGURANÇA OCUPACIONAL, integrando setores, para otimizar, padronizar e obter dados necessários à tomada de decisão e subsidiar
                as estratégias de melhoria contínua do sistema.
              </DefaultText>
              <DefaultText lineHeight="24px" size="small">2 – CAMPO DE APLICAÇÃO</DefaultText>
              <DefaultText lineHeight="16px" size="xs" color="var(--secondary-medium-grey)">
                Aplica-se a toda estrutura organizacional da TELEMONT/PERSONAL.
              </DefaultText>
              <DefaultText lineHeight="24px" size="small">3 – DESCRIÇÃO</DefaultText>
              <DefaultText lineHeight="16px" size="xs" color="var(--secondary-medium-grey)">
                A TELEMONT S.A, empresa prestadora de serviços e soluções integradas para os segmentos de Telecom, (comunicação de voz, dados, transporte de multimídia e tecnologia
                da informação) e Energia (operações técnicas em infraestrutura de linhas de distribuição, média e baixa tensão); e PERSONAL ENERGIA LTDA, tem como objetivo conectar
                pessoas, negócios e tecnologia através de soluções de infraestrutura, promovendo a inclusão e a diversidade.
                A organização estabelece que seus valores sejam disseminados e compartilhados com toda a estrutura organizacional, visando a busca pela excelência e inovação,
                crescimento sustentável e responsabilidade socioambiental no alcance dos seus objetivos. A Telemont/Personal se compromete a:
                <br /><br />
                – Ter o cliente e outras partes interessadas como centro de suas atenções, melhorando continuamente a satisfação em relação aos serviços prestados;
                <br /><br />
                – Proteger e preservar o meio ambiente, trabalhando de forma sustentável para a redução dos impactos ambientais em suas atividades e serviços e na prevenção da
                poluição;
                <br /><br />
                – Preservar a integridade física e o bem-estar dos colaboradores e, por meio da participação e consulta dos trabalhadores e seus representantes, proporcionar um
                ambiente de trabalho seguro e saudável e atuar na prevenção de lesões e problemas de saúde relacionados ao trabalho;
                <br /><br />
                – Identificar e avaliar, riscos a fim de eliminar perigos e reduzir riscos de SSO e melhorar as condições de trabalho;
                <br /><br />
                – Desenvolver processos que garantam o valor Operar de Modo Seguro e assegurar o direito de recusa quanto à execução de qualquer atividade em que as condições de
                trabalho não estejam conformes;
                <br /><br />
                – Disseminar e promover o compromisso com a melhoria contínua do Sistema de Gestão Integrado, para melhorar o desempenho da Qualidade, Segurança, Saúde e Meio
                Ambiente;
                <br /><br />
                – Garantir o atendimento de todos os requisitos e aspectos legais decorrentes das atividades;
                <br /><br />
                – Desenvolver, qualificar e avaliar fornecedores de produtos e serviços que impactam diretamente na qualidade dos serviços prestados, assegurando a
                disponibilidade de informações e recursos necessários para o atendimento dos requisitos legais e padrões normativos, no alcance dos objetivos propostos nesta política;
                <br /><br />
                – Ter excelência em gente e times de alta performance, respeito e simplicidade, trabalhando com conscientização, incentivando e promovendo o treinamento e a
                capacitação dos colaboradores no atendimento aos requisitos técnicos, normativos e legais;
                <br /><br />
                – Disponibilizar recursos e informações necessárias para o desenvolvimento e continuidade do Sistema de Gestão Integrado (SGI). Toda a Liderança deve promover a
                prática constante destas diretrizes na condução da Telemont ao crescimento sustentável e responsável, bem como ao melhor atendimento das necessidades dos clientes.
              </DefaultText>
              <DefaultText lineHeight="24px" size="small">4 – DEFINIÇÕES</DefaultText>
              <DefaultText lineHeight="16px" size="xs" color="var(--secondary-medium-grey)">
                • SGI – Sistema de Gestão Integrado; <br />
                • SSMA – Segurança, Saúde e Meio Ambiente; <br />
                • SSO – Segurança e Saúde Ocupacional.
              </DefaultText>
              <DefaultText lineHeight="24px" size="small">5 – REFERÊNCIAS</DefaultText>
              <DefaultText lineHeight="16px" size="xs" color="var(--secondary-medium-grey)">
                • ABNT NBR ISO 9001:2015 – REQUISITOS DO SISTEMA DE GESTÃO DA QUALIDADE.<br />
                • ABNT NBR ISO 45001:2018 – REQUISITOS NORMATIVOS DE SAÚDE E SEGURANÇA.<br />
                • ABNT NBR ISO 14001:2015 – REQUISITOS NORMATIVOS AMBIENTAIS.<br />
                • PEM-PRE00001 – PRINCÍPIO EMPRESARIAL.<br />
                • PLANEJAMENTO ESTRATÉGICO.<br />
                • MSG-PRE00001 – Manual do SGI.
              </DefaultText>
              <DefaultText lineHeight="24px" size="small">6 – REGISTRO DO SISTEMA DE GESTÃO</DefaultText>
              <DefaultText lineHeight="16px" size="xs" color="var(--secondary-medium-grey)">
                Não se aplica.
              </DefaultText>
            </div>
          </Collapse>
        </div>
      </div>
      <div className={styles["sub-page-content-blue"]}>
        <div className={styles["sgi-policy-banners-container"]}>
          <div className={styles["sgi-minor-policy-banner"]}>
            <img src={imgBannerPoliticaPrivacidade} alt="Imagem ilustrativa política de privacidade" className={styles["banner-image"]} />
            <DefaultText size={isMobile ? 'small' : 'medium'} color="white" style={{ fontFamily: 'Montserrat-Bold', fontSize:'20px' }}>Política de privacidade</DefaultText>
            <DefaultButton variant={"outlined"}
              onClick={() => { openDocument(DOCUMENT_PATHS.politicaDePrivacidade); }}>
              Saiba Mais
            </DefaultButton>
          </div>
          <div className={styles["sgi-large-policy-banner"]}>
            <img src={imgBannerIgualdadeSalarial} alt="Imagem ilustrativa transparência e igualdade salarial" className={styles["banner-image"]} />
            <DefaultText size={isMobile ? 'small' : 'medium'} color="white" style={{ fontFamily: 'Montserrat-Bold', fontSize:'20px' }}>Relatório de Transparência e Igualdade Salarial</DefaultText>
            <DefaultButton variant={"outlined"}
              onClick={() => { openDocument(DOCUMENT_PATHS.relatorioIgualdadeSalarial); }}>
              Saiba Mais
            </DefaultButton>
          </div>
          <div className={styles["sgi-minor-policy-banner"]}>
            <img src={imgBannerRelatorios} alt="Imagem ilustrativa relatório de sustentabilidade" className={styles["banner-image"]} />
            <DefaultText size={isMobile ? 'small' : 'medium'} color="white" style={{ fontFamily: 'Montserrat-Bold', fontSize:'20px' }}>Relatório de Sustentabilidade Telemont</DefaultText>
            <DefaultButton variant={"outlined"}
              onClick={() => { openDocument(DOCUMENT_PATHS.relatorioSustentabilidade); }}>
              Saiba Mais
            </DefaultButton>
          </div>
        </div>
      </div>
    </>
  );
};

export default DocsPoliticas;